import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=6c53b086&scoped=true&"
import script from "./RiskManagement.vue?vue&type=script&lang=js&"
export * from "./RiskManagement.vue?vue&type=script&lang=js&"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=6c53b086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53b086",
  null
  
)

component.options.__file = "RiskManagement.vue"
export default component.exports